import Icon from 'veui/components/Icon'

Icon.register({
  'heart-filled': {
    paths: [
      {
        d: 'M530.26 64A203.46 203.46 0 00384 125.8 203.46 203.46 0 00237.74 64C124.29 64 32 157.55 32 272.55c0 60.33 18.28 122.45 54.33 184.5 28 48.23 66.81 96.66 115.34 143.94 81.73 79.62 162.47 128.41 165.87 130.45a32 32 0 0032.92 0c3.4-2 84.14-50.83 165.87-130.45 48.53-47.28 87.34-95.71 115.34-143.94C717.72 395 736 332.88 736 272.55 736 157.55 643.71 64 530.26 64z'
      }
    ],
    width: '768',
    height: '768'
  }
})
